import { render, staticRenderFns } from "./trainingModulePageNew1.vue?vue&type=template&id=2ca6422a&scoped=true&"
import script from "./trainingModulePageNew1.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew1.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew1.vue?vue&type=style&index=0&id=2ca6422a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6422a",
  null
  
)

export default component.exports